// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_32bbee5fda--wrapper--IrfC9","desktop-card":"_32bbee5fda--desktop-card--b5KSz"};